
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["nav"]

    connect() {
        //this.adjustHeight()
        //this.resizeObserver = new ResizeObserver(() => this.adjustHeight())
        //this.resizeObserver.observe(this.element)
    }

    disconnect() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect()
        }
    }

    // Open from a button with data-comments-url on it
    async open(event) {
        event.preventDefault();

        const panel = document.getElementById("hs-record-comments");
        if (!panel) return;

        // Determine URL: prefer button's data, fallback to panel's comments_url attribute
        const urlFromButton = this.element?.dataset?.commentsUrl;
        const urlFromPanel = panel.getAttribute("comments_url");
        const url = urlFromButton || urlFromPanel;
        if (!url) {
            this.show(panel);
            return;
        }

        try {
            const response = await fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } });
            const html = await response.text();
            panel.innerHTML = html;
        } catch (e) {
            // Optionally handle error state
        }

        this.show(panel);
        // Adjust height after content loads
        setTimeout(() => this.adjustHeight(), 100);
    }

    // Close button inside the panel
    close(event) {
        if (event) event.preventDefault();
        const panel = document.getElementById("hs-record-comments");
        if (!panel) return;
        this.hide(panel);
    }

    adjustHeight() {
        const wrapper = document.getElementById("comments-wrapper");
        if (!wrapper) return;

        const wrapperHeight = wrapper.offsetHeight;
        const screenHeight = window.innerHeight;

        if (wrapperHeight > screenHeight) {
            const header = document.getElementById("comments-wrapper-header");
            const footer = document.getElementById("comments-wrapper-footer");
            const body = document.getElementById("comments-wrapper-body");

            if (!header || !footer || !body) return;

            const screenHeight = window.innerHeight;
            const headerHeight = header.offsetHeight;
            const footerHeight = footer.offsetHeight;

            // Calculate available height for the body
            const availableHeight = screenHeight - headerHeight - footerHeight;

            // Set the body height
            body.style.height = `${availableHeight}px`;

        }
    }


    adjustHeight1() {
        const wrapper = document.getElementById("comments-wrapper");
        if (!wrapper) return;

        const wrapperHeight = wrapper.offsetHeight;
        const screenHeight = window.innerHeight;

        if (wrapperHeight > screenHeight) {
            const header = wrapper.querySelector('.shrink-0:first-child');
            const footer = wrapper.querySelector('.shrink-0:last-child');
            const headerHeight = header ? header.offsetHeight : 0;
            const footerHeight = footer ? footer.offsetHeight : 0;

            const maxNavHeight = screenHeight - headerHeight - footerHeight - 32; // 32px for padding

            // Add height to ul
            const ul = this.navTarget.querySelector('ul[role="list"]');
            alert("eote")
            if (ul) {
                ul.style.height = '750px';
            }
        } else {
            this.navTarget.style.maxHeight = '';
            alert("eote")
            // Remove height from ul
            const ul = this.navTarget.querySelector('ul[role="list"]');
            if (ul) {
                ul.style.height = '';
            }
        }
    }

    // Helpers
    show(panel) {
        panel.classList.remove("hidden");
        panel.classList.remove("translate-y-full");
        panel.setAttribute("aria-hidden", "false");
    }

    hide(panel) {
        panel.classList.add("translate-y-full");
        const transitionMs = this._readTransitionDuration(panel);
        window.setTimeout(() => {
            panel.classList.add("hidden");
            panel.setAttribute("aria-hidden", "true");
        }, transitionMs);
    }

    _readTransitionDuration(el) {
        const cs = window.getComputedStyle(el);
        const dur = cs.transitionDuration || "0s";
        const mult = dur.includes("ms") ? 1 : 1000;
        const first = parseFloat(dur.split(",")[0] || "0");
        return isNaN(first) ? 0 : Math.round(first * mult);
    }
}